import { useEffect } from 'react'
import { useLoadSdkYuno } from '../../hooks'
import { UsePaymentStatus } from './payment-status.types'
import { useTranslation } from 'react-i18next'
import { getCheckoutReturnUrlInLS, getPublicApiKeyInLS } from '../../utils/local-storage'
import { CountryCode } from '@yuno/sdk-web-core/dist/types'
import { redirectTo } from '../../utils'

export const usePaymentStatus: UsePaymentStatus = (checkoutSession) => {
  const { isYunoLoaded } = useLoadSdkYuno()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (isYunoLoaded && checkoutSession) {
      initSdk()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYunoLoaded, checkoutSession])

  const initSdk = async() => {
    const publicApiKey = getPublicApiKeyInLS()
    const checkoutReturnUrl = getCheckoutReturnUrlInLS()

    if (!publicApiKey) {
      throw new Error('There is not Public Api Key')
    }

    const yuno = await Yuno.initialize(publicApiKey)

    await yuno.mountStatusPayment({
      checkoutSession,
      /**
       * Country can be one of CO, BR, CL, PE, EC, UR, MX
       */
      //eslint-disable-next-line
      //@ts-ignore
      countryCode: CountryCode.COLOMBIA,
      /**
       * Language can be one of es, en, pt
       */
      language: i18n.resolvedLanguage as Language,
      /**
       * @param {'READY_TO_PAY' | 'CREATED' | 'SUCCEEDED' | 'REJECTED' | 'CANCELLED' | 'ERROR' | 'DECLINED' | 'PENDING' | 'EXPIRED' | 'VERIFIED' | 'REFUNDED'} data
       */
      yunoPaymentResult(data) {
        if (checkoutReturnUrl?.length) {
          redirectTo(checkoutReturnUrl)
        }
        console.log('yunoPaymentResult', data)
      },
    })
  }
}
